import { render, staticRenderFns } from "./course.vue?vue&type=template&id=51205bc8&scoped=true"
import script from "./course.vue?vue&type=script&lang=js"
export * from "./course.vue?vue&type=script&lang=js"
import style0 from "./course.vue?vue&type=style&index=0&id=51205bc8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51205bc8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51205bc8')) {
      api.createRecord('51205bc8', component.options)
    } else {
      api.reload('51205bc8', component.options)
    }
    module.hot.accept("./course.vue?vue&type=template&id=51205bc8&scoped=true", function () {
      api.rerender('51205bc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/train/course.vue"
export default component.exports